import { HashRouter, Route, Switch } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import appConfig from "./config/appConfig";
import Contact from "./routes/Contact";
import FlyIn from "./routes/FlyIn";
import Memorial from "./routes/Memorial";
import Welcome from "./routes/Welcome";

/**
 * HashRouter mirrors Paratag-Website and means we don't have to teach
 * CloudFront how to rewrite SPA routes — every URL serves /index.html and
 * the hash drives client-side routing.
 */
function App() {
  return (
    <HashRouter>
      <Header />
      <main>
        <Switch>
          <Route exact path={appConfig.paths.home} component={Welcome} />
          <Route exact path={appConfig.paths.flyIn} component={FlyIn} />
          <Route exact path={appConfig.paths.memorial} component={Memorial} />
          <Route exact path={appConfig.paths.contact} component={Contact} />
        </Switch>
      </main>
      <Footer />
    </HashRouter>
  );
}

export default App;
